import { PRIMARY_COLOR, SECONDARY_COLOR } from ".";

export const primaryBlack = "#373737";
export const DarkBlack = "#181818";
export const TextColor = "#4D4D4D";

// export const primaryColor = "#00b300";
export const primaryColor = localStorage.getItem(PRIMARY_COLOR);
export const secondaryColor = localStorage.getItem(SECONDARY_COLOR);
export const primaryDarkColor = "#008000";
export const backgroundColor = "#e6ffee";
export const primaryColorVariant1 = "#00ff00";
